import { render, staticRenderFns } from "./news-technical-error.vue?vue&type=template&id=ef5a07c2&lang=pug&"
import script from "./news-technical-error.vue?vue&type=script&lang=js&"
export * from "./news-technical-error.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports